// extracted by mini-css-extract-plugin
export default {"event-app":"App_event-app__oGAz6"};